import React from "react";
import { Navigate, Outlet } from "react-router-dom/dist";
import useValidationDataKonselor from "../../costumeHooks/useValidationDataKonselor";

export default function AuthValidasiPduli() {
  const { isValidUrl, dataValidationUser } = useValidationDataKonselor();
  console.log("pdlx Check validasi pduli:", isValidUrl, dataValidationUser);
  return (
    <div>
      {isValidUrl ? (
        <>
          <Outlet />
        </>
      ) : (
        <Navigate
          to={
            dataValidationUser?.data?.kodeVC != undefined &&
            dataValidationUser?.data?.kodeVC != null
              ? "/pduli?kodeVC=" + dataValidationUser?.data?.kodeVC
              : "/pduli"
          }
        />
      )}
    </div>
  );
}
